import { struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Params = struct({
	channelId: iotsUtils.UUID,
	messageId: iotsUtils.NotEmptyString,
});
